<template>
  <div class="input-color">
    <span class="label self-center">
      <slot>
        <template v-if="label">{{ label }}</template>
      </slot>
    </span>
    <design-button
      type="color"
      symbol="circle"
      :filled="true"
      class="input-color__button"
      :color="value ?? defaultValue"
      @update:color="$emit('update:value', $event as T)"
    >
      <template #default="{ isInvisible, color }">
        <lucide-icon
          v-if="isInvisible"
          class="input-color__icon"
          name="eye-off"
        />
        <div
          v-else
          class="input-color__circle"
          :style="{ backgroundColor: color as string }"
        ></div>
      </template>
    </design-button>
    <button
      v-if="value"
      type="button"
      class="button--clear"
      :title="$t('actions.reset')"
      @click="$emit('update:value', null as T)"
    >
      <lucide-icon name="refresh-ccw" />
    </button>
  </div>
</template>

<script setup lang="ts" generic="T extends string | null">
import DesignButton from "@core/input/DesignButton.vue";
import LucideIcon from "@core/ui/LucideIcon.vue";

interface Props {
  value?: T;
  defaultValue?: string;
  label?: string;
}
withDefaults(defineProps<Props>(), {
  defaultValue: "#ffffff",
  label: ""
});
defineEmits<{
  (e: "update:value", value: T): void;
}>();
</script>

<style lang="scss">
.input-color {
  display: grid;
  grid-template-columns: minmax(1rem, 1fr) 2.5rem 2.5rem;
  gap: 0.25rem;

  &__icon {
    font-size: 1.25rem;
    font-weight: 300;
  }

  &__circle {
    border-radius: 50%;
    height: 1.25em;
    width: 1.25em;
  }

  &__button {
    height: 2.5rem;
  }
}
</style>
